import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const setCookie = ({
  name,
  value,
  expires = 7,
}: {
  name: string;
  value: string;
  expires?: number;
}) => {
  const expiresDate = new Date();
  expiresDate.setDate(expiresDate.getDate() + expires);

  return cookies.set(name, value, { expires: expiresDate });
};

export const getCookie = ({ name }: { name: string }) => {
  return cookies.get(name);
};

export const removeCookie = ({
  name,
  option,
}: {
  name: string;
  option?: any;
}) => {
  return cookies.remove(name, { ...option });
};
